import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfService } from './TermsOfService';
export const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <footer className="bg-black text-white py-8" data-id="element-71">
      <div className="container mx-auto px-4 text-center" data-id="element-72">
        <p className="mb-4" data-id="element-73">
          © 2025 The Legacy #7 Collector's Edition. All Rights Reserved.
        </p>
        <div className="flex justify-center space-x-6" data-id="element-74">
          <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-white transition" data-id="element-75">
            Privacy Policy
          </button>
          <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-white transition" data-id="element-76">
            Terms of Service
          </button>
          
        </div>
      </div>
      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-77">
        <PrivacyPolicy data-id="element-78" />
      </Modal>
      {/* Terms of Service Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-79">
        <TermsOfService data-id="element-80" />
      </Modal>
    </footer>;
};